import { render } from "./WorkplacePhysicianPage.vue?vue&type=template&id=4c7ba78b&scoped=true"
import script from "./WorkplacePhysicianPage.vue?vue&type=script&lang=js"
export * from "./WorkplacePhysicianPage.vue?vue&type=script&lang=js"

import "./WorkplacePhysicianPage.vue?vue&type=style&index=0&id=4c7ba78b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c7ba78b"]])

export default __exports__